import styled from 'styled-components';

export const FormLabel = styled.span`
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: -0.12px;
`;
